import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getStaticContent } from "../i18n/staticPages";

const TermsPage = () => {
  const sc = getStaticContent();
  const c = sc.terms;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <header className="bg-slate-900/80 backdrop-blur-sm border-b border-slate-700 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/nkt-bee-logo.png" alt="NKT Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold text-white">NKT - Teklif Hazırla</span>
          </Link>
          <Link to="/">
            <Button variant="outline" className="border-amber-500 text-amber-400 hover:bg-amber-500/10">
              {sc.common.home}
            </Button>
          </Link>
        </div>
      </header>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-white mb-4">{c.title}</h1>
            <p className="text-slate-400">{c.lastUpdated}</p>
          </div>

          <div className="space-y-6">
            {c.sections.map((section, idx) => (
              <Card key={idx} className="bg-slate-800/50 border-slate-700">
                <CardHeader>
                  <CardTitle className="text-amber-400">{section.h}</CardTitle>
                </CardHeader>
                <CardContent className="text-slate-300 space-y-4">
                  {section.blocks.map((block, bIdx) => {
                    if (block.ul) {
                      return (
                        <ul key={bIdx} className="list-disc list-inside space-y-2 ml-4">
                          {block.ul.map((li, liIdx) => <li key={liIdx}>{li}</li>)}
                        </ul>
                      );
                    }
                    if (block.contact) {
                      return (
                        <div key={bIdx} className="bg-slate-700/30 p-4 rounded-lg space-y-2">
                          <p><strong className="text-white">{c.emailWord}:</strong> info@nktteklif.com</p>
                          <p><strong className="text-white">{c.phoneWord}:</strong> 0532 346 89 20</p>
                          <p><strong className="text-white">{c.addressWord}:</strong> Kurtuluş Mh. 64016 Bina No:20 Kat:0 Daire No:1 Seyhan/Adana</p>
                        </div>
                      );
                    }
                    return <p key={bIdx}>{block.p}</p>;
                  })}
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/">
              <Button className="bg-amber-600 hover:bg-amber-700">{sc.common.backHome}</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
